import { getBenchMaterial, getProfileMaterial, getPanelMaterial } from '../reducers/materialStore';
import { isTurnstileError } from './turnstileErrorFilter';
let imageUpdateTimer;
let isUserInteraction = (previousId) => { if (previousId) return true; }


let trackActions = {
    'MATERIALIMAGE_UPDATE_STARTED': (action, store, tracker) => { imageUpdateTimer = performance.now(); },
    'MATERIALIMAGE_UPDATE_COMPLETE': (action, store, tracker) => { tracker.trackTiming("userinteraction", "materialImageUpdated", performance.now() - imageUpdateTimer) },
    'mainSlideChanged': (action, store, tracker) => { tracker.trackScreenview(action.title) },
    'MEASUREMENTS_SKIPPED': (action, store, tracker) => { tracker.trackEvent('userinteraction', 'measurements skipped') },
    'NEWPLAN': (action, store, tracker) => { tracker.trackEvent('userinteraction', 'new plan') },
    'CHANGE_SHAPE': (action, store, tracker) => { tracker.trackEvent("userinteraction", "change shape " + action.shape.name); },
    'CHANGE_MODEL': (action, store, tracker) => { tracker.trackEvent("userinteraction", "change model " + action.model.name); },
    'STOVE_CHANGED': (action, store, tracker) => { tracker.trackEvent("userinteraction", "change stove " + action.stove); },
    'CHANGE_PANELINGDIRECTION': (action, store, tracker) => { tracker.trackEvent("userinteraction", "change paneling direction " + action.direction); },
    'PLAN_SENT': (action, store, tracker) => { tracker.trackEvent('system', 'plan sent') },
    'LIGHTING_CHANGED': (action, store, tracker) => { tracker.trackEvent("userinteraction", "change lighting  " + JSON.stringify(action)); },
    'CHANGE_PANEL_MATERIAL': (action, store, tracker) => {
        let state = store.getState();
        if (isUserInteraction(state.paneling.panelMaterial)) {
            let material = action.id > 0 ? getPanelMaterial(store.getState(), action.id).name : "ei paneelia";
            tracker.trackEvent("userinteraction", "Panelmaterial changed " + action.id + " " + material);
        }
    },
    'CHANGE_PROFILE_MATERIAL': (action, store, tracker) => {
        let state = store.getState();
        if (isUserInteraction(state.benchModel.profileMaterial)) {
            tracker.trackEvent("userinteraction", "Profilematerial changed " + action.id + " " + getProfileMaterial(store.getState(), action.id).name);
        }
    },
    'CHANGE_BENCH_MATERIAL': (action, store, tracker) => {
        let state = store.getState();
        if (isUserInteraction(state.benchModel.material)) {
            tracker.trackEvent("userinteraction", "Benchmaterial changed " + action.id + " " + getBenchMaterial(store.getState(), action.id).name);
        }
    }
}

const logger = tracker => store => next => action => {
    if (trackActions[action.type]) {
        trackActions[action.type](action, store, tracker)
    }
    let result = next(action);
    return result;
}

let crashReporter = tracker => store => next => action => {
    try {
        return next(action);
    } catch (err) {
        if (!isTurnstileError(err)) {
            tracker.trackException(err);
        }
        throw err;
    }
}
export { crashReporter, logger };
